import { SupportEmail } from "@/models/support-email.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class SupportEmailRest {
  sendEmail(data: SupportEmail): Observable<any> {
    const url: string = `/user/email-support`;
    return api.post(url, data);
  }
}